module.exports = __webpack_public_path__ + "media/images/weather/255_day-b00467c6fbc065cbc1f639cc53e38efc.png";